const forgotPasswordInitialValues = {
  email: ""
};

export default forgotPasswordInitialValues;
